import { CREDIT_FORM_TOUCH_ACTIONS } from 'src/utils/enums/user-store-actions.enum';
import { IUser } from 'src/utils/interfaces/user';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useCreditForm = () => {
    const dispatch = useDispatch();

    const isCreditFormTouched = useSelector(
        (state: IUser) => state.isCreditFormTouched,
    );

    const markCreditFormTouched = useCallback(() => {
        if (!isCreditFormTouched) {
            dispatch({
                type: CREDIT_FORM_TOUCH_ACTIONS.MARK_CREDIT_FORM_TOUCHED,
            });
        }
    }, [isCreditFormTouched, dispatch]);

    const markCreditFormUntouched = useCallback(() => {
        if (isCreditFormTouched) {
            dispatch({
                type: CREDIT_FORM_TOUCH_ACTIONS.MARK_CREDIT_FORM_UNTOUCHED,
            });
        }
    }, [isCreditFormTouched, dispatch]);

    return {
        isCreditFormTouched,
        markCreditFormTouched,
        markCreditFormUntouched,
    };
};
